import Link from "next/link";
import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box";

import { CartButtonWithSwipeableDrawer } from "src/lib/components/header/default";
import Typography from "@mui/material/Typography"; // ==============================================================
import Drawer from "@mui/material/Drawer";
import IconDefault from "../../icon/default";
import { Paragraph } from "../../salify-next-layout/default/components/Typography";
import Image from "next/image";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import SearchInput from "./search-input";
import { toAssetImages } from "src/lib/utils";

// ==============================================================
const MobileHeader = (props) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const toggleSearchBar = () => setSearchBarOpen((state) => !state);

  const ICON_STYLE = {
    color: "grey.600",
    fontSize: 20,
  };
  return (
    <>
      <FlexBetween width="100%">
        <Link href="/">
          {props.logoUrl && (
            <Image
              src={toAssetImages(props.logoUrl)}
              alt=""
              width={props.logoWidth ?? 50}
              height={props.logoHeight ?? 50}
            />
          )}
          <Typography variant="h4" component="h1" fontWeight="700">
            {props.name}
          </Typography>
        </Link>

        <FlexBox justifyContent="end" flex={1} gap={1}>
          <IconButton sx={{ bgcolor: "#F3F5F9" }} onClick={toggleSearchBar}>
            <IconDefault sx={ICON_STYLE} icon="mdi:magnify" fontSize={"30px"} />
          </IconButton>
          <CartButtonWithSwipeableDrawer
            cartUrl={props.cartUrl}
            checkoutUrl={props.checkoutUrl}
            productUrlPrefix={props.productUrlPrefix}
          />
        </FlexBox>
      </FlexBetween>

      {/* SEARCH FORM DRAWER */}
      <Drawer
        open={searchBarOpen}
        anchor="top"
        onClose={toggleSearchBar}
        sx={{
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            width: "auto",
            padding: 2,
            height: "100vh",
          }}
        >
          <FlexBetween mb={1}>
            <Paragraph>
              <SalifyFallback.Label path="Browse products" default="Tìm kiếm sản phẩm" />
            </Paragraph>

            <IconButton onClick={toggleSearchBar}>
              <IconDefault icon="mdi:close" />
            </IconButton>
          </FlexBetween>

          {/* CATEGORY BASED SEARCH FORM */}
          <SearchInput searchCallback={toggleSearchBar} />
        </Box>
      </Drawer>
    </>
  );
};

export default MobileHeader;
